import { render, staticRenderFns } from "./createDingd.vue?vue&type=template&id=57a6c235&scoped=true"
import script from "./createDingd.vue?vue&type=script&lang=js"
export * from "./createDingd.vue?vue&type=script&lang=js"
import style0 from "./createDingd.vue?vue&type=style&index=0&id=57a6c235&prod&scoped=true&lang=css"
import style1 from "./createDingd.vue?vue&type=style&index=1&id=57a6c235&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a6c235",
  null
  
)

export default component.exports